import { Heart, Sparkles, Share2 } from 'lucide-react'
import { FadeIn } from '@/components/templates/blocks/FadeIn.js'
import { Container, Text } from '@/components/ui/index.js'
import styles from './FeaturesSection.module.css'

const features = [
  {
    icon: Heart,
    title: '나만의 청첩장',
    desc: '인사말, 갤러리, 식순, 지도, RSVP 등 13개 섹션을 자유롭게 구성하세요',
  },
  {
    icon: Sparkles,
    title: 'AI 웨딩 포토',
    desc: '사진 한 장이면 AI가 15가지 스타일의 웨딩 포토를 만들어 드립니다',
  },
  {
    icon: Share2,
    title: '간편한 공유',
    desc: '카카오톡, 링크 복사로 누구에게나 쉽게 공유할 수 있습니다',
  },
]

export function FeaturesSection() {
  return (
    <section className={styles.section}>
      <Container size="lg">
        <FadeIn>
          <Text variant="heading-lg" align="center" className={styles.heading}>
            이렇게 만들어집니다
          </Text>
        </FadeIn>
        <div className={styles.grid}>
          {features.map((f) => (
            <FadeIn key={f.title}>
              <div className={styles.card}>
                <div className={styles.iconWrap}>
                  <f.icon size={24} />
                </div>
                <Text variant="heading-sm">{f.title}</Text>
                <Text variant="body-md" color="secondary">{f.desc}</Text>
              </div>
            </FadeIn>
          ))}
        </div>
      </Container>
    </section>
  )
}
